<template>
  <v-card
    flat
    outlined
    rounded="lg"
    class="flex"
    height="100%"
    color="cardbg"
    elevation="10"
  >
    <v-card-title
      color="primary"
      :style="`padding: calc(${scale} * 0.4rem);
        line-height: calc(${scale} * 0.75rem);
        font-size: calc(${scale} * 0.7rem);`"
      class="font-weight-medium d-flex justify-space-between"
    >
      <span class="titlecolor--text">
        Production Status Live
      </span>
      <span class="subtitlecolor--text">{{ now }}</span>
    </v-card-title>
    <v-card-text
      style="line-height: normal; height: 90%;"
      :style="`padding: calc(${scale} * 0.4rem);`"
    >
      <WidgetLoading v-show="loading" />
      <div
        class="h-full justify-space-between"
        v-show="!loading"
      >
        <div
          class="text-uppercase"
          style="width: 100%;"
        >
          <div class="d-flex justify-space-between">
            <div style="height: 45%;" class="d-flex">
              <div
                class="d-flex justify-center"
                style="flex-direction: column;"
              >
                <div
                  class="titlecolor--text font-weight-regular"
                  :style="`font-size: calc(${scale} * 1.5rem);`"
                >
                  {{ machinestatus.running }}
                </div>
                <div
                  class="subtitlecolor--text d-flex align-center"
                  :style="`font-size: calc(${scale} * 0.8rem); height: 100%`"
                >
                  <span>Running</span>
                </div>
              </div>
            </div>
            <div style="height: 45%;" class="d-flex justify-center">
              <div
                class="d-flex justify-center"
                style="flex-direction: column;"
              >
                <div
                  class="error--text font-weight-regular"
                  :style="`font-size: calc(${scale} * 1.5rem);`"
                >
                  {{ machinestatus.down }}
                </div>
                <div
                  class="error--text d-flex align-center"
                  :style="`font-size: calc(${scale} * 0.8rem); height: 100%`"
                >
                  <span>Down</span>
                </div>
              </div>
            </div>
            <div style="height: 45%;" class="d-flex justify-end">
              <div
                class="d-flex justify-center"
                style="flex-direction: column;"
              >
                <div
                  class="titlecolor--text font-weight-regular"
                  :style="`font-size: calc(${scale} * 1.5rem);`"
                >
                  {{ machinestatus.noplan }}
                </div>
                <div
                  class="subtitlecolor--text d-flex align-center"
                  :style="`font-size: calc(${scale} * 0.8rem); height: 100%`"
                >
                  <span>No Plan</span>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div style="height: 45%; width: 50%" class="d-flex justify-center">
              <div
                class="d-flex justify-center align-center"
                style="flex-direction: column; width: 100%;"
              >
                <div
                  class="titlecolor--text font-weight-regular"
                  :style="`font-size: calc(${scale} * 1.5rem); margin-right: 3%`"
                >
                  {{ targetqty.toLocaleString("en-IN") }}
                </div>
                <div
                  class="subtitlecolor--text d-flex align-center"
                  :style="`font-size: calc(${scale} * 0.8rem); height: 100%`"
                >
                  <span>Target Qty.</span>
                </div>
              </div>
            </div>
            <div style="height: 45%; width: 50%" class="d-flex justify-center">
              <div
                class="d-flex justify-center align-center"
                style="flex-direction: column; width: 100%;"
              >
                <div
                  class="titlecolor--text font-weight-regular"
                  :style="`font-size: calc(${scale} * 1.5rem);`"
                >
                  {{ actualqty.toLocaleString("en-IN") }}
                </div>
                <div
                  class="subtitlecolor--text d-flex align-center"
                  :style="`font-size: calc(${scale} * 0.8rem); height: 100%`"
                >
                  <span>Actual Qty.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="text-align: center; color: #fff; margin-bottom: 5%;">
          <SemiProgressCircle
            :scale="scale"
            :value="oee"
            valueSuffix="%"
            :colorclass="colorclass"
            title="Cell OEE"
            :loading="loading"
            :borderWidth="40 * scale"
            :titleSize="`calc(${scale} * 0.6rem)`"
            :valueSize="`calc(${scale} * 1.9rem)`"
            style="width: 96%;  height: 90%; margin: 10% auto;"
          />
          <div
            class="d-flex justify-space-between"
            :style="`font-size: calc(${scale} * 0.8rem); width: 96%`"
          >
            <div class="d-flex align-start">
              <span
                class="subtitlecolor--text d-flex align-center mr-1"
                style="line-height: 1.2;">
                A%
              </span>
              <span
                class="titlecolor--text font-weight-regular"
                :style="`font-size: calc(${scale} * 1.5rem); line-height: 1;`"
              >
                {{ Math.floor(availability) }}
              </span>
            </div>
            <div class="d-flex align-start">
              <span
                class="subtitlecolor--text d-flex align-center mr-1"
                style="line-height: 1.2;"
              >
                P%
              </span>
              <span
                class="titlecolor--text font-weight-regular"
                :style="`font-size: calc(${scale} * 1.5rem); line-height: 1;`"
              >
                {{ Math.floor(performance) }}
              </span>
            </div>
            <div class="d-flex align-start">
              <span
                class="subtitlecolor--text d-flex align-center mr-1"
                style="line-height: 1.2;"
              >
                Q%
              </span>
              <span
                class="titlecolor--text font-weight-regular"
                :style="`font-size: calc(${scale} * 1.5rem); line-height: 1;`"
              >{{ Math.floor(quality) }}</span>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import SemiProgressCircle from '../SemiProgressCircle.vue';
import WidgetLoading from '../WidgetLoading.vue';

export default {
  name: 'ProductionStatus',
  props: {
    scale: {
      type: Number,
      default: 1,
    },
  },
  components: {
    SemiProgressCircle,
    WidgetLoading,
  },
  data() {
    return {
      interval: null,
      loading: false,
      machinestatus: {
        running: 0,
        down: 0,
        noplan: 0,
      },
      targetqty: 0,
      actualqty: 0,
      now: '',
      rejectionquantity: 0,
      runtime: 0,
      availabletime: 0,
    };
  },
  computed: {
    ...mapState('cellwiseProductionDashboard', [
      'machines',
      'serverTime',
      'dataFromJSON',
      'intervalfetch',
      'config',
      'currentShift',
      'currentDate',
      'shifts',
    ]),
    ...mapGetters('cellwiseProductionDashboard', [
      'shiftStartTime',
    ]),
    cellname() {
      return this.$route.query.selectedcell;
    },
    availability() {
      if (this.runtime && this.availabletime) {
        return (this.runtime * 100) / this.availabletime;
      }
      return 0;
    },
    performance() {
      if (this.actualqty && this.targetqty) {
        return (this.actualqty / this.targetqty) * 100;
      }
      return 0;
    },
    quality() {
      if (this.actualqty) {
        return ((this.actualqty - this.rejectionquantity) / this.actualqty) * 100;
      }
      return 0;
    },
    oee() {
      const oeeCalc = (this.availability * this.performance * this.quality) / 10000;
      return Math.round(oeeCalc * 100) / 100;
    },
    colorclass() {
      let color = 'yellow-chart';
      if (this.oee > this.config.greaterthangreen) {
        color = 'green-chart';
      }
      if (this.oee < this.config.lessthanred) {
        color = 'red-chart';
      }
      return color;
    },
  },
  watch: {
    '$route.query.selectedcell': {
      async handler() {
        if (!this.dataFromJSON) {
          await this.fetchData();
        } else if (this.dummydata) {
          await this.dummydata();
        }
      },
    },
    async currentDate() {
      if (!this.dataFromJSON) await this.fetchData();
    },
    async currentShift() {
      if (!this.dataFromJSON) await this.fetchData();
    },
  },
  async mounted() {
    this.setTime();
    setInterval(() => {
      this.setTime();
    }, 60000);

    if (this.dataFromJSON) {
      await this.dummydata();
    } else {
      await this.fetchData();
      const delay = (this.intervalfetch || 25) * 1000;
      this.interval = setInterval(async () => {
        await this.fetchData();
      }, delay);
    }
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    ...mapActions('cellwiseProductionDashboard', ['getReports', 'getServerTime', 'getFileData', 'getMachines']),

    async dummydata() {
      try {
        const res = await this.getFileData('jsondata/productionstatus.json');
        if (res) this.setProductionData(res.machines || []);
      } catch (error) {
        this.setProductionData([]);
      }
    },
    async fetchData() {
      if (this.loading) return;
      this.loading = true;
      try {
        if (!this.machines || this.machines.length === 0) {
          await this.getMachines();
        }

        let activeSite = this.$store.state.user?.activeSite
         || this.$store.state.auth?.user?.site_id;
        if (!activeSite) {
          try {
            const swxUser = JSON.parse(localStorage.getItem('user') || '{}');
            activeSite = swxUser?.site_id || swxUser?.site?.id || swxUser?.customer?.site_id;
          } catch (e) { /* ignore */ }
        }
        if (!activeSite && this.machines?.length > 0) {
          activeSite = this.machines[0].siteId || this.machines[0].siteid;
        }

        if (!activeSite) {
          this.loading = false;
          return;
        }

        let yyyymmddDate = this.currentDate;
        if (!this.currentDate || String(this.currentDate).length > 8) {
          const dateObj = this.currentDate ? new Date(this.currentDate) : new Date();
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const day = String(dateObj.getDate()).padStart(2, '0');
          yyyymmddDate = parseInt(`${year}${month}${day}`, 10);
        }

        if (!this.currentShift) {
          this.loading = false;
          return;
        }

        const payload = {
          siteid: activeSite,
          dateVal: yyyymmddDate,
          shiftVal: this.currentShift,
          all: true,
        };

        if (this.cellname) {
          payload.machinecell = this.cellname;
        }

        const reportName = 'shiftliveshopfloor';
        const result = await this.getReports({ reportName, payload });

        if (result) {
          const parsedResult = typeof result === 'string' ? JSON.parse(result) : result;
          let finalData = parsedResult.reportData ? parsedResult.reportData : parsedResult;
          if (typeof finalData === 'string' && finalData !== '') {
            finalData = JSON.parse(finalData);
          }

          if (finalData && finalData.machines) {
            this.setProductionData(finalData.machines);
          } else {
            this.setProductionData([]);
          }
        } else {
          this.setProductionData([]);
        }
      } catch (error) {
        this.setProductionData([]);
      } finally {
        this.loading = false;
      }
    },
    setProductionData(machinesArray) {
      if (!Array.isArray(machinesArray)) return;

      let running = 0;
      let down = 0;
      let noplan = 0;
      let targetqty = 0;
      let actualqty = 0;
      let rejectionquantity = 0;
      let runtime = 0;
      let availabletime = 0;

      let computedWorkingTime = 28800000;
      if (this.serverTime && this.shiftStartTime) {
        computedWorkingTime = this.serverTime - this.shiftStartTime;
      }
      if (computedWorkingTime <= 0) {
        computedWorkingTime = this.serverTime - (this.shiftStartTime - 86400000);
        if (computedWorkingTime <= 0) computedWorkingTime = 28800000;
      }
      machinesArray.forEach((d) => {
        const dbCellName = d.machinecell || d.cell || d.cellname;
        if (!this.cellname || this.cellname === dbCellName) {
          const status = (d.machinestatus || d.status || '').toUpperCase();
          if (status === 'UP' || status === 'RUNNING') {
            running += 1;
          } else if (status === 'DOWN') {
            down += 1;
          } else if (status === 'NOPLAN' || status === 'NO PLAN') {
            noplan += 1;
          }

          let mQty = 0;
          let mRejection = 0;
          let mApiTimeTarget = 0;

          if (d.production && d.production.length > 0) {
            mQty = d.production.reduce((sum, p) => sum + (p.produced || 0), 0);
            mRejection = d.production.reduce((sum, p) => sum + (p.rejected || 0), 0);
            mApiTimeTarget = d.production.reduce((sum, p) => sum + (p.timeTarget || 0), 0);
          } else {
            mQty = d.qty || d.actualquantity || 0;
            mRejection = d.rqty || d.rejectionquantity || 0;
            mApiTimeTarget = d.stdproduction || 0;
          }

          let mTarget = 0;
          const mPerformance = d.performance || 0;

          if (mPerformance > 0) {
            mTarget = mQty / (mPerformance / 100);
          } else {
            mTarget = mApiTimeTarget;
          }
          targetqty += Math.round(mTarget);
          actualqty += mQty;
          rejectionquantity += mRejection;
          runtime += d.runtime || 0;
          availabletime += d.workingTime
            || d.availabletime || d.shiftAvailableTime || computedWorkingTime;
        }
      });

      this.machinestatus = { running, down, noplan };
      this.targetqty = targetqty;
      this.actualqty = actualqty;
      this.rejectionquantity = rejectionquantity;
      this.runtime = runtime;
      this.availabletime = availabletime;
    },
    async setTime() {
      try {
        await this.getServerTime();
        this.now = this.dateFormat();
      } catch (error) {
        this.now = 'Time Unavailable';
      }
    },

    dateFormat() {
      if (!this.serverTime) return '';
      try {
        const date = new Date(this.serverTime);
        const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
        const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
        const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
        const currentHours = date.getHours();
        const currentMin = date.getMinutes();
        const hour = (`0${currentHours}`).slice(-2);
        const min = (`0${currentMin}`).slice(-2);
        return `${day} ${month} ${year} | ${hour}:${min}`;
      } catch (e) {
        return '';
      }
    },
  },

};
</script>
